/**
 *
 * @param {{
 *   insertRadio?: boolean,
 *   insertViewImportButton?: boolean,
 * }} [options]
 */
export function constructImportsTableHeaders(options) {
  return [
    options?.insertRadio
      ? {
        key: "__select_radio",
        headerTitle: "選択",
      }
      : null,
    options?.insertViewImportButton
      ? {
        key: "__view_import",
        headerTitle: "見る"
      }
      : null,
    {
      key: "importedAt",
      headerTitle: "インポート日時",
    },
    {
      key: "importMethod",
      headerTitle: "インポート方法",
    },
  ]
    .filter(header => header)
}
